import { StadiumIcon } from './StadiumIcon';

/**
 * author: Google
 * id 5FDB24B6-FF16-4575-A794-E5CCEB95CC81
 * name stadium
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/stadium.svg
 * tags
 * - Sport 
 * - Places 
 */
export const ArenaIcon = StadiumIcon;
export default ArenaIcon